export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mtproto.worker.eb0be31857e3eae1abea.bundle.worker.js");
}
